import { render, staticRenderFns } from "./TlmCheckout.vue?vue&type=template&id=bca92630"
import script from "./TlmCheckout.vue?vue&type=script&lang=js"
export * from "./TlmCheckout.vue?vue&type=script&lang=js"
import style0 from "./TlmCheckout.vue?vue&type=style&index=0&id=bca92630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FamilyShoppingListSteps: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/family/ShoppingListSteps.vue').default})
